import { render, staticRenderFns } from "./CardLastCall.vue?vue&type=template&id=f654c744&scoped=true"
import script from "./CardLastCall.vue?vue&type=script&lang=js"
export * from "./CardLastCall.vue?vue&type=script&lang=js"
import style0 from "./CardLastCall.vue?vue&type=style&index=0&id=f654c744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f654c744",
  null
  
)

export default component.exports